// Faceted search (feature 12): one group of checkboxes per facet the backend
// defines for the workspace (GET /knowledge/facets — counts only cover the
// documents the caller may see). Values within a facet are OR-ed, facets AND-ed.
import { useEffect, useState } from "react";
import API_BASE_URL from "../config";
import { toggleFacetValue } from "./searchUtils";

export default function FacetPanel({ database, selection, onChange }) {
  const [facets, setFacets] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const qs = database ? `?database=${encodeURIComponent(database)}` : "";
    fetch(`${API_BASE_URL}/api/v1/knowledge/facets${qs}`)
      .then((r) => (r.ok ? r.json() : { facets: [] }))
      .then((d) => { if (!cancelled) setFacets(Array.isArray(d.facets) ? d.facets : []); })
      .catch(() => { if (!cancelled) setFacets([]); });  // degrade: no panel, search still works
    return () => { cancelled = true; };
  }, [database]);

  const usable = facets.filter((f) => f.values.length > 1 || (selection[f.id] || []).length > 0);
  if (usable.length === 0) return null;
  const hasSelection = Object.keys(selection).length > 0;

  return (
    <div className="facet-panel" data-testid="facet-panel">
      {usable.map((facet) => {
        const selectedCount = (selection[facet.id] || []).length;
        return (
          <fieldset key={facet.id} className="facet-group">
            <legend className="facet-legend">
              <span>{facet.label}</span>{" "}
              {selectedCount > 0 &&<span className="ds-badge ds-badge--info">{selectedCount}</span>}
            </legend>
            <div className="facet-values">
              {facet.values.map((v) => (
                <label key={v.value} className="facet-value">
                  <input
                    type="checkbox"
                    checked={(selection[facet.id] || []).includes(v.value)}
                    onChange={() => onChange(toggleFacetValue(selection, facet.id, v.value))}
                  />
                  <span className="facet-label" dir="auto">{v.label}</span>{" "}
                  <span className="facet-count">({v.count})</span>
                </label>
              ))}
              {facet.truncated && <span className="facet-more">…</span>}
            </div>
          </fieldset>
        );
      })}
      {hasSelection && (
        <button type="button" className="ds-btn ds-btn--ghost ds-btn--sm facet-clear" onClick={() => onChange({})}>
          Clear filters
        </button>
      )}
    </div>
  );
}
